import { BotonExportarExcel, Group, TablaSkeleton, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { OrganizacionAdmin } from "@/lib/types";
import { OrganizacionRow } from "./OrganizacionRow";

export function OrganizacionesTable({
  cargando = false,
  organizaciones,
  obtenerFilas,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  organizaciones: OrganizacionAdmin[];
  /** Trae TODAS las páginas con la búsqueda actual · para el export. */
  obtenerFilas: () => Promise<OrganizacionAdmin[]>;
}) {
  return (
    <>
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="organizaciones"
          hoja="Organizaciones"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Nombre", value: (o) => o.nombre },
            { header: "RFC", value: (o) => o.rfc },
            { header: "Sociedad SAP", value: (o) => o.numeroSociedad },
            { header: "Estado", value: (o) => (o.estaActiva ? "Activa" : "Inactiva") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Nombre</Th>
            <Th>RFC</Th>
            <Th>Sociedad SAP</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        {cargando ? (
          <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, {}, { align: "right" }]} filas={15} />
        ) : (
          <Tbody>
            {organizaciones.map((o) => (
              <OrganizacionRow key={o.id} org={o} />
            ))}
          </Tbody>
        )}
      </Table>
    </>
  );
}
